export const formatTransportPrice = (value: any): string => {
  if (!value || value === '0' || value === 0) {
    return 'Tarjouksen mukaan';
  }
  return `${value} €`;
};
